export interface UmpireStatisticType {
  type: 'statistic_type';
  name: string;
  resource_type: 'SquadPlayer' | 'Squad';
  context_type: 'CompetitionSeason' | 'Match';
  available_stats: string[];
}
